import clsx from 'clsx';
import React from 'react';

interface NavigationProps {
  letters: [string, boolean];
}

const BrandNavigation = ({ letters }: NavigationProps) => {
  const letterArr = Object.entries(letters).map(([key, value]) => ({
    key,
    value,
  }));

  const scrollToElement = (key, value) => {
    const categoryId = 'brandCategory' + key.toUpperCase();

    if (value) {
      document?.getElementById(categoryId)?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
  };

  return (
    <nav className="w-full overflow-x-auto whitespace-nowrap scrollbar-none">
      <ul className="flex gap-1 lg:justify-center">
        {letterArr.map((letter) => (
          <li
            className={clsx(
              letter.value ? 'cursor-pointer' : 'text-gray-300',
              'px-2 py-3 text-xl font-bold uppercase'
            )}
            key={letter.key}
            onClick={() => scrollToElement(letter.key, letter.value)}
          >
            {letter.key}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BrandNavigation;
